define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/jquery/src/ajax/var/location.js
// module id = 906
// module chunks = 1